import React from 'react';
import {PropTypes} from 'prop-types';

/* Styles */
import './DateContent.less';

export const DateContent = ({
    isMobile,
    lastMessageDate = '',
    unreadMessages,
}) => {
    const dateContentClassName = `DateContent__date ${
        isMobile ? 'DateContent__date--xs text-left' : 'text-right'
    }`;

    return (
        <div className={dateContentClassName}>
            <em>{lastMessageDate}</em>
            {unreadMessages && (
                <span
                    className="DateContent__unread-dot text-brand"
                    data-testid="unread-message"
                >
                    {'\u25CF'}
                </span>
            )}
        </div>
    );
};

DateContent.propTypes = {
    isMobile: PropTypes.bool,
    lastMessageDate: PropTypes.string,
    unreadMessages: PropTypes.bool,
};
